import React from 'react';
import * as Slider from '@radix-ui/react-slider';

interface Props {
  data: {
    teamSize: string;
  };
  updateData: (data: Partial<typeof Props['data']>) => void;
}

export const TeamSize = ({ data, updateData }: Props) => {
  const teamSizes = ['1-10', '11-50', '51-200', '201+'];
  const currentIndex = teamSizes.indexOf(data.teamSize);

  return (
    <div>
      <h2 className="text-2xl font-semibold text-center text-gray-900 mb-2">
        How big is your team?
      </h2>
      <p className="text-center text-gray-600 mb-8">
        We've worked with small startups and large enterprises.
      </p>

      <div className="space-y-8">
        <div className="flex justify-between gap-2">
          {teamSizes.map((size, index) => (
            <button
              key={size}
              onClick={() => updateData({ teamSize: size })}
              className={`flex-1 px-4 py-3 rounded-lg text-sm font-medium transition-colors
                ${data.teamSize === size
                  ? 'bg-[#4B6BFB] text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
            >
              {size}
            </button>
          ))}
        </div>

        <div className="text-center">
          <span className="text-xl font-medium text-gray-900">
            {data.teamSize} employees
          </span>
        </div>
      </div>
    </div>
  );
};